export default __webpack_public_path__ + "static/media/NeueMontreal-Italic.c23121ce.woff2";